import React from 'react';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import uploadMagicBoxSchedule from './uploadMagicBoxSchedule';

const MagicBoxDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.magicBox}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.magicBox].uploadSchedule]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/uploadSchedule`}
				component={uploadMagicBoxSchedule}
				exact
			/>
			<Redirect to={`${path}/uploadSchedule`} />
		</Switch>
	);
};

export default MagicBoxDashboard;
